<template>
    <div v-bind:class="sampleBatchWrapperClasses"
         @click.stop.prevent="handleClick">
        <div class="sample-title"><b>{{data.fullName}}</b></div>
        <v-menu
                v-if="showMenu"
                v-model="showMenu"
                :position-x="menuX"
                :position-y="menuY"
                :close-on-content-click="false"
                absolute
                offset-y
                max-width="400"
        >
            <v-card>
                <v-card-title>Sample #<b> <router-link :to="{ name: 'updatePgtCase', params: { caseId: data.caseSystemId }}">{{data.fullName}}</router-link></b></v-card-title>
                <v-card-text class="text--primary">
                    <v-autocomplete
                            ref="batchSelector"
                            auto-select-first
                            autofocus
                            v-model="batchModel"
                            :items="batchItems"
                            :search-input.sync="batchSearch"
                            hide-no-data
                            hide-selected
                            item-text="systemId"
                            item-value="id"
                            label="Run"
                            placeholder="Start typing run title"
                            :menu-props="{ contentClass: 'case-selector' }"
                            clearable
                            @input="handleBatchChange"
                            return-object
                    >
                        <template v-slot:item="{ index, item }">
                            <v-list-item-content>
                                <v-list-item-title>{{item.systemId}}</v-list-item-title>
                            </v-list-item-content>
                        </template>
                    </v-autocomplete>
                    <v-autocomplete
                            :disabled="!batchModel"
                            v-model="positionInBatch"
                            :items="availablePositionsInBatch"
                            ref="positionAutocomplete"
                            hide-selected
                            label="Position"
                            placeholder="Start typing position"
                            clearable
                            no-data-text="No available position"
                            @input="handlePositionChange"
                            return-object
                    ></v-autocomplete>
                    <v-divider class="mt-3 mb-3"></v-divider>
                    <div>
                        <v-btn block
                               :disabled="progress('moveSampleToSuitableBatch')"
                               :loading="progress('moveSampleToSuitableBatch')"
                               color="primary"
                               @click="handleMoveSampleToSuitableBatchButtonClick">To Run
                        </v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-menu>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import _ from "lodash";
    import api from "../../store/modules/batches/api";
    import NotificationService from "../../services/notificationService";
    export default {
        name: 'MissingSampleItem',
        props: {
            data: Object
        },
        data() {
            return {
                showMenu: false,
                menuX: 0,
                menuY: 0,
                batchModel: null,
                batchSearch: null,
                batchItems: [],
                positionInBatch: null
            }
        },
        watch: {
            batchSearch(input) {
                this.searchBatch(input)
            },
            showMenu(value) {
                if (!value) {
                    return
                }

                setTimeout(() => {this.$nextTick(this.$refs['batchSelector'].focus)}, 200)
            }
        },
        computed: {
            ...mapGetters('batches', {
                progress: 'progress'
            }),
            sampleBatchWrapperClasses() {
                return {
                    'sample-wrapper': true,
                }
            },
            availablePositionsInBatch() {
                if (!this.batchModel) {
                    return []
                }

                return _.range(1, this.batchModel.size + 1, 1)
            }
        },
        methods: {
            ...mapActions('batches', {
                getMissingSamples: 'getMissingSamples',
                moveSampleToArchive: 'moveSampleToArchive',
                moveSampleToSuitableBatch: 'moveSampleToSuitableBatch',
                addSample: 'addSample',
            }),
            handleClick(e) {
                this.menuX = e.clientX
                this.menuY = e.clientY
                this.$nextTick(() => {
                    this.showMenu = true
                })
            },
            handleBatchChange() {
                this.$nextTick(() => {
                    this.$refs['positionAutocomplete'].focus();
                    this.$refs['positionAutocomplete'].activateMenu()
                })
            },
            reset() {
                this.showMenu = false
                this.menuX = 0
                this.menuY = 0
                this.batchModel = null
                this.batchSearch = null
                this.batchItems = []
            },
            searchBatch: _.debounce(async function (searchStr) {
                if (!searchStr || searchStr.length === 0) {
                    return
                }

                try {
                    this.batchItems = await api.search(searchStr)
                } catch (e) {
                    NotificationService.error('Unable to find batches. Try again later')
                }
            }, 500),
            async handleMoveSampleToArchiveButtonClick() {
                await this.moveSampleToArchive(this.data.id)
                this.reset()
            },
            async handleMoveSampleToSuitableBatchButtonClick() {
                await this.moveSampleToSuitableBatch(this.data.id)
                this.reset()
            },
            async handlePositionChange() {
                const result = await this.addSample({
                    sampleId: this.data.id,
                    batchId: this.batchModel.id,
                    position: this.positionInBatch
                })

                if (!result) {
                    return
                }
                this.reset()
                this.getMissingSamples()
            }
        }

    }
</script>

<style scoped>
    .sample-wrapper {
        display: inline-block;
        padding: 5px;
        margin: 3px;
        width: 80px;
        height: 60px;
        border: 1px solid black;
        background-color: #e2e2e2;
        cursor: pointer;
        overflow: auto;
    }

    .sample-wrapper:hover {
        background-color: #c4c4c4 !important;
    }

    .sample-title {
        font-size: 12px;
        line-height: 1;
        text-align: center;
        margin-top: 18px;
    }

</style>